import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
    h1: {
      color: "#0F202B",
      fontSize:'50px',
      fontWeight:'600',
    },
  },
});

export default theme;
